import {
  Box,
  Divider,
  Typography
} from '@mui/material'

import { useContext, useEffect } from 'react'

// Components
import Bar from 'src/components/common/Bar'
import Portrait from 'src/components/common/Portrait'

// Context
import { InventoryDataContext } from 'src/store/inventory/Store'
import { setEquippedStats } from 'src/store/stats/actions'
import { ItemDataContext } from 'src/store/items/Store'
import { StatsDataContext, StatsDispatchContext } from 'src/store/stats/Store'

const portraitStatusWrapper = {
  display: 'flex',
  flexDirection: 'row',
  gap: '8px',
  justifyContent: 'space-between',
  width: '100%'
}

const flexRow = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center'
}

const statusWrapper = {
  ...flexRow,
  flexGrow: '100',
  flexWrap: 'wrap',
  justifyContent: 'center',
  maxWidth: '80%'
}

const Stats = () => {
  const { items } = useContext(ItemDataContext)
  const { stats } = useContext(StatsDataContext)
  const { dispatchStats } = useContext(StatsDispatchContext)
  const { inventory } = useContext(InventoryDataContext)

  useEffect(() => {
    setEquippedStats(dispatchStats, items, inventory)
  }, [inventory.equipped])

  // development build logs
  useEffect(() => {
    if (process.env.REACT_APP_BENCHMARK === 'true') { console.log('Stats mounted') }
    return process.env.REACT_APP_BENCHMARK === 'true' ? () => console.log('Stats unmounted') : () => { }
  }, [])

  useEffect(() => {
    if (process.env.REACT_APP_BENCHMARK === 'true') { console.log('Stats rendered') }
  })

  return (
    <>
      <Box sx={portraitStatusWrapper}>
        <Portrait/>
        <Box sx={statusWrapper} className="hp-ap-bars">
          <Bar currentValue={stats.total.player_hp} maximumValue={stats.total.player_hp_max} label='HP' />
          <Bar currentValue={stats.total.player_ap} maximumValue={stats.total.player_ap_max} label='AP' />
        </Box>
      </Box>
      <Divider sx={{ marginY: 2 }} />
      <Box sx={{ display: 'flex', flexDirection: 'column', maxWidth: '100%', marginY: 1, justifyContent: 'space-between' }} className="stats">
        <Box sx={flexRow}>
          <Box sx={{ maxWidth: '20%' }}>
            <Typography display='inline'>STR {stats.total.player_str}</Typography>
          </Box>
          <Box sx={{ maxWidth: '75%' }}>
            <Bar currentValue={stats.player.player_str_exp > 100 ? 100 : stats.player.player_str_exp} maximumValue={100}/>
          </Box>
          <Box sx={{ maxWidth: '10%' }}>
            <Typography display='inline'>XP</Typography>
          </Box>
        </Box>
        <Box sx={flexRow}>
          <Box sx={{ maxWidth: '20%' }}>
            <Typography display='inline'>DEX {stats.total.player_dex}</Typography>
          </Box>
          <Box sx={{ maxWidth: '75%' }}>
            <Bar currentValue={stats.player.player_dex_exp > 100 ? 100 : stats.player.player_dex_exp} maximumValue={100}/>
          </Box>
          <Box sx={{ maxWidth: '10%' }}>
            <Typography display='inline'>XP</Typography>
          </Box>
        </Box>
        <Box sx={flexRow}>
          <Box sx={{ maxWidth: '20%' }}>
            <Typography display='inline'>VIT {stats.total.player_vit}</Typography>
          </Box>
          <Box sx={{ maxWidth: '75%' }}>
            <Bar currentValue={stats.player.player_vit_exp > 100 ? 100 : stats.player.player_vit_exp} maximumValue={100}/>
          </Box>
          <Box sx={{ maxWidth: '10%' }}>
            <Typography display='inline'>XP</Typography>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default Stats
